import { render, staticRenderFns } from "./ScreenFichaDocente.vue?vue&type=template&id=a8534d16"
import script from "./ScreenFichaDocente.vue?vue&type=script&lang=js"
export * from "./ScreenFichaDocente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports